import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { AIPImageUpload } from "@wlocalhost/ngx-email-builder";
import { HttpClient } from "@angular/common/http";
import { assetBaseUrl, baseUrl } from "src/environments/environment";

@Component({
  selector: "tail-image-upload",
  templateUrl: "./image-upload.component.html",
  styleUrls: ["./image-upload.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageUploadComponent extends AIPImageUpload {
  private readonly http = inject(HttpClient);

  uploading = false;

  private joinBaseUrl(pathOrUrl: string): string {
    // If backend already returned absolute URL, keep it.
    if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl;

    const p = (pathOrUrl || "").startsWith("/") ? pathOrUrl : `/${pathOrUrl}`;

    // IMPORTANT: environment.baseUrl usually points to API root (often ends with /api/).
    // Images are served from the asset host origin (no /api).
    const asset = (assetBaseUrl || "").replace(/\/+$/, "");
    if (asset) return `${asset}${p}`;

    // Fallback: derive origin from baseUrl or window location.
    try {
      const origin = new URL(baseUrl).origin;
      return `${origin}${p}`;
    } catch {
      return `${window.location.origin}${p}`;
    }
  }

  async onFileSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement | null;
    const file = input?.files?.[0];
    if (!file) return;

    this.uploading = true;
    try {
      const form = new FormData();
      form.append("file", file);

      // Same-origin API endpoint (served by SMXEmailPlatform.API)
      const res = await this.http
        .post<{ path?: string }>(`${baseUrl}smxEmailPlatform/Assets/uploadEmailBuilderImage`, form)
        .toPromise();

      // Backend returns only the relative path; frontend joins with origin.
      const serverPathOrUrl = res?.path;
      if (serverPathOrUrl) {
        // Store relative path in builder state (no port/path issues).
        this.value = serverPathOrUrl;
        // Ensure [(value)]="src" in the parent updates immediately.
        this.valueChange.next(this.value);
      }
    } finally {
      this.uploading = false;
      if (input) input.value = "";
    }
  }
}
